import {Component, EventEmitter, Host, Input, Optional, Output} from '@angular/core';
import {SessionStorageService, WSEntities} from 'ac-infra';
import {NetworkGroupsFilterComponent} from '../network-groups-filter/network-groups-filter.component';
import {Subject} from "rxjs";
import * as _ from 'lodash';

@Component({
    selector: 'network-groups-selection',
    styleUrls: ['./network-groups-selection.component.less'],
    templateUrl: './network-groups-selection.component.html',
})
export class NetworkGroupsSelectionComponent {

    @Input() isMultiple = true;
    @Input() isVisible = true;
    @Input() ngDisabled = false;
    @Input() sortItems = false;
    @Input() model: any;
    @Input() items: any;
    @Input() alternativeName: string;
    @Input() label: string;
    @Output() acChanged = new EventEmitter<any>();

    itemsInitializeInternally = false;

    _type: 'TOPOLOGY' | 'ENDPOINT' | 'CUSTOMER';

    customerFilter;
    customerFilterTypes = [
        {value: 'fullName', text: 'Full Name'},
        {value: 'customerMsTenantId', text: 'MS Tenant ID'},
    ];

    @Input() set type(type) {
        this._type = type;
        this.setTitle();

        if (this.itemsInitializeInternally) {
            this.getItems();
        }
    }

    constructor(private wsEntities: WSEntities,
                @Host() @Optional() public networkGroupsFilterComponent: NetworkGroupsFilterComponent) {
        this.customerFilter = SessionStorageService.getData('customerFilter') || 'fullName';
    }

    ngOnInit() {
        !this.label && this.setTitle();

        if (this.items === undefined) {
            this.itemsInitializeInternally = true;
            this.getItems();
        }

        if(this._type === 'CUSTOMER'){
            this.customerFilterTypeChanged(this.customerFilter);
        }
    }

    getItems = () => {
        this.items = this.wsEntities.getEntitiesArray(this._type === 'CUSTOMER' ? 'customers' : 'groups').filter((group) => group.type === this._type);
    };

    setTitle = () => {
        let label = this._type.toLowerCase();

        if (this._type !== 'CUSTOMER') {
            label += ' Group';
        }

        this.label = label + (this.isMultiple ? 's' : '');
    };

    customerFilterTypeChanged($event: any) {
        this.customerFilter = $event;
        SessionStorageService.setData('customerFilter', $event);
        const customers = _.cloneDeep(this.wsEntities.getEntitiesArray('customers').filter((group) => group.type === this._type));
        customers.forEach((customer) => {
            if(customer[this.customerFilter]){
                customer.name = customer.name + ' (' + customer[this.customerFilter] +')';
            }
        });

        this.items = customers;
    }
}
